import { Select, type SelectOptionProps, useSelect } from '@loadsmart/loadsmart-ui'
import { Layout, Tag, Text } from '@loadsmart/miranda-react'

import { type OpenDockLoadTypes } from '../../domain/Shipment'
import { formatLoadTypeInfo } from '../../presenters/openDockLoadTypePresenter'

export function CustomOption({ value }: SelectOptionProps) {
  const select = useSelect()
  const option = select.getOption(value) as OpenDockLoadTypes

  return (
    <Select.Option value={value}>
      <Layout.Stack gap="spacing-1">
        <Layout.Group gap="spacing-1" align="center">
          <Tag>{option.direction === 'Inbound' ? <>&rarr; IN</> : <>&larr; OUT</>}</Tag>
          {option.name}
        </Layout.Group>
        <Layout.Group>
          <Text variant="body-sm" color="color-text-tertiary">
            {formatLoadTypeInfo(option)}
          </Text>
        </Layout.Group>
      </Layout.Stack>
    </Select.Option>
  )
}
